import React, { useState } from 'react';
import { RotateCcw } from 'lucide-react';
import { cn } from '../cn';
import Button from '../Button';
import Select from '../form/Select';
import { TableFilterSearch } from '../table-filter';
import { resolveUsdPeriodDateRange, validateUsdCustomPeriod } from './ledgerUtils';
const PERIODS = [
    { value: 'today', label: 'Today' },
    { value: '7d', label: '7d' },
    { value: '30d', label: '30d' },
    { value: 'custom', label: 'Custom' },
];
export const PortalUsdWalletFiltersBar = ({ draft, onDraftChange, onApply, onReset, applyDisabled, className, }) => {
    const [customError, setCustomError] = useState(null);
    const handlePeriodClick = (period) => {
        if (period === 'custom') {
            onDraftChange({ period });
        }
        else {
            const { dateFrom, dateTo } = resolveUsdPeriodDateRange(period, '', '');
            onDraftChange({ period, dateFrom, dateTo });
        }
        setCustomError(null);
    };
    const handleApply = () => {
        if (draft.period === 'custom') {
            const err = validateUsdCustomPeriod(draft.dateFrom, draft.dateTo);
            if (err) {
                setCustomError(err);
                return;
            }
        }
        setCustomError(null);
        onApply();
    };
    return (React.createElement("div", { className: cn('flex flex-col gap-4 border-b border-gray-100 bg-gray-50/60 px-4 py-4', className) },
        React.createElement("div", { className: "flex flex-wrap items-center gap-2" },
            React.createElement("span", { className: "text-xs font-medium text-gray-600" }, "Period"),
            PERIODS.map((p) => (React.createElement("button", { key: p.value, type: "button", onClick: () => handlePeriodClick(p.value), className: cn('rounded-lg border px-3 py-1.5 text-sm font-medium transition', draft.period === p.value
                    ? 'border-orange-500 bg-orange-50 text-orange-800'
                    : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50') }, p.label))),
            draft.period === 'custom' ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "flex items-center gap-1.5" },
                    React.createElement("label", { htmlFor: "usd-ledger-date-from", className: "shrink-0 text-xs font-medium text-gray-600" }, "From"),
                    React.createElement("input", { id: "usd-ledger-date-from", type: "date", value: draft.dateFrom, onChange: (e) => onDraftChange({ dateFrom: e.target.value }), className: "h-9 w-[9.5rem] rounded-lg border border-gray-200 bg-white px-3 text-sm outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-500/20" })),
                React.createElement("div", { className: "flex items-center gap-1.5" },
                    React.createElement("label", { htmlFor: "usd-ledger-date-to", className: "shrink-0 text-xs font-medium text-gray-600" }, "To"),
                    React.createElement("input", { id: "usd-ledger-date-to", type: "date", value: draft.dateTo, onChange: (e) => onDraftChange({ dateTo: e.target.value }), className: "h-9 w-[9.5rem] rounded-lg border border-gray-200 bg-white px-3 text-sm outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-500/20" })))) : null,
            customError ? React.createElement("p", { className: "w-full text-xs text-red-600" }, customError) : null),
        React.createElement("div", { className: "flex flex-col gap-3 lg:flex-row lg:flex-wrap lg:items-end" },
            React.createElement("div", { className: "min-w-[200px] flex-1 lg:max-w-sm" },
                React.createElement("label", { className: "mb-1 block text-xs font-medium text-gray-600" }, "Search"),
                React.createElement(TableFilterSearch, { placeholder: "Transaction ID, provider, reference\u2026", value: draft.query, onChange: (e) => onDraftChange({ query: e.target.value }), clearable: false })),
            React.createElement("div", { className: "w-full sm:w-40" },
                React.createElement("label", { className: "mb-1 block text-xs font-medium text-gray-600" }, "Type"),
                React.createElement(Select, { selectSize: "sm", hidePlaceholder: true, value: draft.typeFilter, onChange: (e) => onDraftChange({ typeFilter: e.target.value || 'all' }) },
                    React.createElement("option", { value: "all" }, "All types"),
                    React.createElement("option", { value: "deposit" }, "Deposit"),
                    React.createElement("option", { value: "withdrawal" }, "Withdrawal"),
                    React.createElement("option", { value: "purchase_credits" }, "Purchase credits"),
                    React.createElement("option", { value: "adjustment" }, "Adjustment"),
                    React.createElement("option", { value: "reversal" }, "Reversal"))),
            React.createElement("div", { className: "w-full sm:w-40" },
                React.createElement("label", { className: "mb-1 block text-xs font-medium text-gray-600" }, "Status"),
                React.createElement(Select, { selectSize: "sm", hidePlaceholder: true, value: draft.statusFilter, onChange: (e) => onDraftChange({ statusFilter: e.target.value || 'all' }) },
                    React.createElement("option", { value: "all" }, "All statuses"),
                    React.createElement("option", { value: "completed" }, "Completed"),
                    React.createElement("option", { value: "pending" }, "Pending"),
                    React.createElement("option", { value: "processing" }, "Processing"),
                    React.createElement("option", { value: "failed" }, "Failed"),
                    React.createElement("option", { value: "cancelled" }, "Cancelled"))),
            React.createElement("div", { className: "flex shrink-0 gap-2 pb-0.5 lg:ml-auto" },
                onReset ? (React.createElement(Button, { type: "button", variant: "outline", size: "sm", onClick: onReset, className: "gap-1.5" },
                    React.createElement(RotateCcw, { className: "h-3.5 w-3.5", "aria-hidden": true }),
                    "Reset")) : null,
                React.createElement(Button, { type: "button", size: "sm", onClick: handleApply, disabled: applyDisabled, className: "bg-orange-600 text-white hover:bg-orange-700" }, "Apply Filter")))));
};
export default PortalUsdWalletFiltersBar;
